var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "el-grid-list" }, [
    _c("div", { staticClass: "emd-container" }, [
      _c("div", {
        staticClass: "emd-status-bar",
        class: _vm.statusClass(_vm.invite.status.key),
      }),
      _c(
        "div",
        { staticClass: "emd-container__content" },
        [
          _c(
            "div",
            { staticClass: "el-chunk" },
            [
              _c(
                "emd-text",
                {
                  attrs: {
                    "variation-color": "subtle",
                    type: "label",
                    size: "tiny",
                    tag: "h4",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("invite.detail.status")))]
              ),
            ],
            1
          ),
          _c(
            "emd-badge",
            {
              class: _vm.statusClass(_vm.invite.status.key),
              attrs: { text: _vm.invite.status.value },
            },
            [_vm._v(_vm._s(_vm.invite.status.value))]
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "emd-container" }, [
      _c(
        "div",
        { staticClass: "emd-container__content" },
        [
          _c(
            "div",
            { staticClass: "el-chunk" },
            [
              _c(
                "emd-text",
                {
                  attrs: {
                    "variation-color": "subtle",
                    type: "label",
                    size: "tiny",
                    tag: "h4",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("invite.detail.permission")))]
              ),
            ],
            1
          ),
          _c("emd-text", { attrs: { size: "section", tag: "p" } }, [
            _vm._v(_vm._s(_vm.invite.permission)),
          ]),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "emd-container" }, [
      _c(
        "div",
        { staticClass: "emd-container__content" },
        [
          _c(
            "div",
            { staticClass: "el-chunk" },
            [
              _c(
                "emd-text",
                {
                  attrs: {
                    "variation-color": "subtle",
                    type: "label",
                    size: "tiny",
                    tag: "h4",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("invite.detail.created-at")))]
              ),
            ],
            1
          ),
          _c("emd-text", { attrs: { size: "section", tag: "p" } }, [
            _vm._v(_vm._s(_vm.invite.created_at)),
          ]),
        ],
        1
      ),
    ]),
    !_vm.inviteIsCanceled(_vm.invite.status.key)
      ? _c("div", { staticClass: "emd-container" }, [
          _c(
            "div",
            { staticClass: "emd-container__content" },
            [
              _c(
                "div",
                { staticClass: "el-chunk" },
                [
                  _c(
                    "emd-text",
                    {
                      attrs: {
                        "variation-color": "subtle",
                        type: "label",
                        size: "tiny",
                        tag: "h4",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("invite.detail.expires-at")))]
                  ),
                ],
                1
              ),
              _c("emd-text", { attrs: { size: "section", tag: "p" } }, [
                _vm._v(_vm._s(_vm.invite.expires_at)),
              ]),
            ],
            1
          ),
        ])
      : _vm._e(),
    _vm.inviteIsCanceled(_vm.invite.status.key)
      ? _c("div", { staticClass: "emd-container" }, [
          _c(
            "div",
            { staticClass: "emd-container__content" },
            [
              _c(
                "div",
                { staticClass: "el-chunk" },
                [
                  _c(
                    "emd-text",
                    {
                      attrs: {
                        "variation-color": "subtle",
                        type: "label",
                        size: "tiny",
                        tag: "h4",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("invite.detail.canceled-at")))]
                  ),
                ],
                1
              ),
              _c("emd-text", { attrs: { size: "section", tag: "p" } }, [
                _vm._v(_vm._s(_vm.invite.canceled_at)),
              ]),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }